module.exports = __webpack_public_path__ + "img/ism.2864dd6e.jpg";